<div *ngIf="!isCookiePolicyEvaluated" class="overlay">
  <div class="cookie-consent">
    <h1>{{ translations?.Title }}</h1>
    <p [innerHTML]="translations?.Message"></p>
    <button (click)="acceptCookies()">{{ translations?.BtnAccept}}</button>
    <button (click)="rejectCookies()">{{ translations?.BtnReject}}</button>
  </div>
</div>
